module.exports = __webpack_public_path__ + "img/reports_blue.51ac6e69.svg";